import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { from, switchMap } from 'rxjs';
import { FingerprintService } from '@core/services/fingerprint.service';


export const fingerprintInterceptor: HttpInterceptorFn = (req, next) => {

  const service = inject(FingerprintService);

  return from(service.getFingerprint()).pipe(
    switchMap(
      (fingerprint) => {
        if (!fingerprint) {
          return next(req);
        }

        return from(service.getDeviceName()).pipe(
          switchMap(
            (devicename) => next(
              req.clone(
                {
                  setHeaders: {
                    'x-device-name': devicename,
                    'x-device-fingerprint': fingerprint,
                  }
                }
              )
            )
          )
        );
      }
    )
  );
}
